import React, { useState } from 'react';
import GrammarRulesExercise from './GrammarRulesExercise';
import './GrammarRulesExerciseBoard.css';

const GRAMMAR_RULES_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%)', marginRight: 20, flexShrink: 0
  }}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  </span>
);

const GrammarRulesExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false,
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { content, title, level } = exerciseData;

  if (!content) {
    return (
      <div className="grammar-rules-board-error">
        <p>Error: Invalid Grammar Rules exercise data</p>
      </div>
    );
  }

  const handleExpand = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(true);
    if (onSelect) onSelect();
    if (onExpand) onExpand();
  };

  const handleClose = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(false);
    if (onClose) onClose();
  };

  return (
    <div className="grammar-rules-exercise-board">
      {!isExpanded ? (
        <div
          className={`grammar-rules-preview unified-exercise-preview gr-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={handleExpand}
        >
          {GRAMMAR_RULES_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Grammar Rules Exercise'}</div>
            <div className="unified-preview-meta">
              Grammar Rules · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="grammar-rules-expanded">
          <GrammarRulesExercise
            content={content}
            title={title}
            level={level}
            onClose={handleClose}
            updateAttributes={onUpdate}
            isStudent={isStudent}
          />
        </div>
      )}
    </div>
  );
};

export default GrammarRulesExerciseBoard;
